import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Error404 extends Page{
    constructor(){
        super({
            id : 'error404',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}